import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const stayMotivated = useStore((state) => state.stayMotivated);
  const setStayMotivated = useStore((state) => state.setStayMotivated);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.stayMotivated.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={stayMotivated}
          onChange={(value) => {
            setStayMotivated(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'stay-motivated',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Support from people close to me"}>
            <span>❤️</span> {t('onboarding.stayMotivated.options.support')}
          </Option>
          <Option value={"Being able to share my journey with others"}>
            <span>💬</span> {t('onboarding.stayMotivated.options.share')}
          </Option>
          <Option value={"A break would help me reset"}>
            <span>☕</span> {t('onboarding.stayMotivated.options.break')}
          </Option>
          <Option value={"Nothing, I can handle it on my own"}>
            <span>💪</span> {t('onboarding.stayMotivated.options.nothing')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
